import { useMemo, useState } from "react";

import { CheckCircle2, Clock, Globe, Instagram, Mail, MapPin, Package, Phone, Shield, Truck, Users } from "lucide-react";

import { toast } from "sonner";



import brandLogo from "../assets/images/logo-nobg.png";

import heroImage from "../assets/images/hero.png";

import { default as whatsappHeroIcon, default as whatsappIcon } from "../assets/images/zap.png";

import frota1Image from "../assets/images/andrade/frota1.png";

import frota2Image from "../assets/images/andrade/frota2.png";


import boxesImage from "../assets/images/freesources/boxes.jpg";

import livingRoomImage from "../assets/images/freesources/pexels-cottonbro-4568693.jpg";

import windowBoxesImage from "../assets/images/freesources/pexels-cottonbro-4569338.jpg";

import { Button } from "../components/ui/button";

import { Card, CardContent } from "../components/ui/card";

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../components/ui/carousel";

import { Input } from "../components/ui/input";

import { Label } from "../components/ui/label";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

import { Textarea } from "../components/ui/textarea";



const BRAND_BLUE = "#123B7A";

const BRAND_BLUE_DARK = "#0A2A57";

const BRAND_ORANGE = "#F59E0B";

const BRAND_ORANGE_SOFT = "#F7E3B0";

const COMPANY_PHONE = "+351 933 053 533";

const COMPANY_INSTAGRAM_URL = "https://www.instagram.com/luizfernandocostadeandrade/";

const COMPANY_INSTAGRAM_HANDLE = "@luizfernandocostadeandrade";



const initialFormData = {

  name: "",

  phone: "",

  email: "",

  fromCity: "",

  toCity: "",

  moveDate: "",

  homeSize: "",

  notes: "",

};

const getWhatsAppPhone = (phone) => {

  const digits = phone.replace(/\D/g, "");

  return digits.startsWith("351") ? digits : `351${digits}`;
};

const buildWhatsAppMessage = (formData, language) => {

  const lines =
    language === "pt"
      ? [
        "Olá, gostaria de pedir um orçamento.",
        "",
        `Nome: ${formData.name}`,
        `Telefone: ${formData.phone}`,
        `Email: ${formData.email}`,
        `Origem: ${formData.fromCity}`,
        `Destino: ${formData.toCity}`,
        `Data da mudança: ${formData.moveDate}`,
        `Tipologia: ${formData.homeSize}`,
        `Notas: ${formData.notes || "-"}`,
      ]
      : [
        "Hello, I would like to request a quote.",
        "",
        `Name: ${formData.name}`,
        `Phone: ${formData.phone}`,
        `Email: ${formData.email}`,
        `Origin: ${formData.fromCity}`,
        `Destination: ${formData.toCity}`,
        `Move date: ${formData.moveDate}`,
        `Property size: ${formData.homeSize}`,
        `Notes: ${formData.notes || "-"}`,
      ];

  return lines.join("\n");
};



const content = {

  pt: {

    nav: { home: "Início", services: "Serviços", process: "Processo", contact: "Contacto" },

    hero: {

      title: "Mudanças sem ruído, planeadas com rigor.",

      subtitle:

        "A Andrade coordena mudanças residenciais e comerciais em Portugal e na Europa com equipa segurada, datas claras e acompanhamento rápido.",

      cta: "Pedir orçamento",

      badges: ["Equipa segurada", "Resposta rápida", "Cobertura Portugal + Europa"],

      support: "Mudanças em Portugal e Europa",

    },

    form: {

      title: "Pedir orçamento",

      intro: "Envie os dados principais e respondemos com uma proposta personalizada.",

      name: "Nome",

      phone: "Telefone",

      email: "Email",

      from: "Origem",

      to: "Destino",

      date: "Data da mudança",

      size: "Tipologia",

      sizePlaceholder: "Selecionar",

      sizeOptions: ["Studio", "T1", "T2", "T3+", "Escritório"],

      notes: "Notas",

      notesPlaceholder: "Elevador, embalamento, acesso difícil, horários, etc.",

      submit: "Enviar pedido",

      sending: "A enviar...",

      success: "Pedido enviado. Entraremos em contacto em breve.",

      error: "Não foi possível enviar o pedido. Tente novamente.",

    },

    sections: {

      whyTitle: "Porque escolher a Andrade",

      whySubtitle: "Operação simples, comunicação clara e execução cuidada.",

      servicesTitle: "Serviços",

      servicesSubtitle: "Apoio completo antes, durante e depois da mudança.",

      processTitle: "Como trabalhamos",

      processSubtitle: "Quatro passos diretos, sem surpresas.",

      coverageTitle: "Cobertura",

      coverageSubtitle: "Recolhas e entregas em Portugal continental e rotas europeias selecionadas.",

      finalTitle: "Precisa de uma mudança organizada?",

      finalText: "Partilhe o seu percurso e tratamos do planeamento.",

      finalButton: "Falar com a equipa",

    },

    footer: {

      company: "Andrade Mudanças & Transporte",

      about: "Mudanças residenciais e comerciais com foco em pontualidade, proteção dos bens e comunicação objetiva.",

      phone: COMPANY_PHONE,
      phones: [COMPANY_PHONE],
      instagram: COMPANY_INSTAGRAM_HANDLE,

      email: "contacto@andrade-mudancas.pt",

      hours: "Seg-Sex 08:00-18:00",

      copyright: "© 2026 Andrade Mudanças & Transporte. Todos os direitos reservados.",

    },

  },

  en: {

    nav: { home: "Home", services: "Services", process: "Process", contact: "Contact" },

    hero: {

      title: "Moving planned properly, without the usual chaos.",

      subtitle:

        "Andrade handles residential and commercial relocations across Portugal and Europe with insured crews, clear timelines, and fast follow-up.",

      cta: "Request a quote",

      badges: ["Insured team", "Fast response", "Portugal + Europe coverage"],

      support: "Portugal and Europe moving support",

    },

    form: {

      title: "Request a quote",

      intro: "Send the essentials and we will reply with a tailored estimate.",

      name: "Name",

      phone: "Phone",

      email: "Email",

      from: "Origin",

      to: "Destination",

      date: "Move date",

      size: "Property size",

      sizePlaceholder: "Select",

      sizeOptions: ["Studio", "1 Bedroom", "2 Bedrooms", "3+ Bedrooms", "Office"],

      notes: "Notes",

      notesPlaceholder: "Lift access, packing support, narrow stairs, timing constraints, etc.",

      submit: "Send request",

      sending: "Sending...",

      success: "Request sent. We will contact you shortly.",

      error: "We could not send your request. Please try again.",

    },

    sections: {

      whyTitle: "Why Andrade",

      whySubtitle: "Simple operation, clear communication, careful execution.",

      servicesTitle: "Services",

      servicesSubtitle: "Support before, during, and after the move.",

      processTitle: "How we work",

      processSubtitle: "Four direct steps, no surprises.",

      coverageTitle: "Coverage",

      coverageSubtitle: "Collections and deliveries across mainland Portugal and selected European routes.",

      finalTitle: "Need a move that stays organised?",

      finalText: "Share your route and we will plan the next step.",

      finalButton: "Talk to the team",

    },

    footer: {

      company: "Andrade Moving & Transport",

      about: "Residential and commercial moving focused on punctuality, protection of goods, and direct communication.",

      phone: COMPANY_PHONE,
      phones: [COMPANY_PHONE],
      instagram: COMPANY_INSTAGRAM_HANDLE,

      email: "contact@andrade-mudancas.pt",

      hours: "Mon-Fri 08:00-18:00",

      copyright: "© 2026 Andrade Moving & Transport. All rights reserved.",

    },

  },

};



const valueCards = [

  {

    icon: Shield,

    pt: { title: "Cobertura segurada", description: "Equipas e operação pensadas para reduzir risco e proteger os bens." },

    en: { title: "Insured coverage", description: "Crews and handling designed to reduce risk and protect goods." },

  },

  {

    icon: Users,

    pt: { title: "Coordenação humana", description: "Acompanhamento direto, sem formulários esquecidos nem respostas vagas." },

    en: { title: "Human coordination", description: "Direct follow-up without forgotten forms or vague replies." },

  },

  {

    icon: Clock,

    pt: { title: "Planeamento claro", description: "Janela horária definida e alinhamento antes da mudança." },

    en: { title: "Clear planning", description: "Defined time window and alignment before move day." },

  },

];



const serviceCards = [

  {

    icon: Truck,

    pt: { title: "Mudanças locais", description: "Mudanças urbanas e intermunicipais com carga, descarga e proteção básica." },

    en: { title: "Local moving", description: "Urban and inter-city moves with loading, unloading, and basic protection." },

  },

  {

    icon: Globe,

    pt: { title: "Rotas europeias", description: "Apoio para mudanças entre Portugal e destinos europeus selecionados." },

    en: { title: "European routes", description: "Support for moves between Portugal and selected European destinations." },

  },

  {

    icon: Package,

    pt: { title: "Embalamento", description: "Opção de materiais, desmontagem simples e organização de volumes." },

    en: { title: "Packing", description: "Optional materials, simple dismantling, and volume organisation." },

  },

];



const processSteps = {

  pt: [

    "Recebemos os dados do percurso e do volume.",

    "Validamos detalhes operacionais e janela pretendida.",

    "Enviamos proposta e confirmamos a reserva.",

    "Executamos a mudança e fechamos a entrega.",

  ],

  en: [

    "We receive the route and volume details.",

    "We confirm operational constraints and preferred timing.",

    "We send the estimate and confirm the booking.",

    "We execute the move and complete delivery.",

  ],

};



const coverage = {

  pt: ["Lisboa", "Porto", "Braga", "Coimbra", "Aveiro", "Faro", "Madrid", "Paris", "Bruxelas", "Luxemburgo"],

  en: ["Lisbon", "Porto", "Braga", "Coimbra", "Aveiro", "Faro", "Madrid", "Paris", "Brussels", "Luxembourg"],

};



const gallerySlides = [

  {

    image: boxesImage,

    pt: {

      eyebrow: "Preparação",

      title: "Planeamento antes do transporte",

      text: "Organizar, separar e proteger desde o primeiro momento reduz atrasos e danos evitáveis.",

    },

    en: {

      eyebrow: "Preparation",

      title: "Planning before transport",

      text: "Sorting, staging, and protecting items early reduces delays and avoidable damage.",

    },

  },

  {

    image: livingRoomImage,

    pt: {

      eyebrow: "Proteção",

      title: "Volumes pensados para a mudança",

      text: "Caixas e acondicionamento corretos fazem diferença real na execução e no descarregamento.",

    },

    en: {

      eyebrow: "Protection",

      title: "Volumes prepared for moving",

      text: "Proper boxing and protection make a real difference during execution and unloading.",

    },

  },

  {

    image: windowBoxesImage,

    pt: {

      eyebrow: "Organização",

      title: "Transição mais previsível",

      text: "Quando a casa está preparada por zonas, a operação fica mais clara para a equipa e para o cliente.",

    },

    en: {

      eyebrow: "Organisation",

      title: "A more predictable transition",

      text: "When the home is staged by zones, the move becomes clearer for both crew and client.",

    },

  },

];



function LandingPage() {

  const [language, setLanguage] = useState("pt");

  const [formData, setFormData] = useState(initialFormData);

  const [isSubmitting, setIsSubmitting] = useState(false);



  const t = useMemo(() => content[language], [language]);



  const handleInputChange = (field, value) => {

    setFormData((prev) => ({ ...prev, [field]: value }));

  };



  const scrollToQuote = () => {

    document.getElementById("quote-form")?.scrollIntoView({ behavior: "smooth", block: "start" });

  };



  const handleSubmit = (event) => {

    event.preventDefault();

    setIsSubmitting(true);



    try {

      const whatsappUrl = `https://wa.me/${getWhatsAppPhone(t.footer.phone)}?text=${encodeURIComponent(
        buildWhatsAppMessage(formData, language)
      )}`;

      const whatsappWindow = window.open(whatsappUrl, "_blank", "noopener,noreferrer");

      if (!whatsappWindow) {

        throw new Error("WhatsApp window was blocked");

      }



      toast.success(t.form.success);

      setFormData(initialFormData);

    } catch (error) {

      console.error(error);

      toast.error(t.form.error);

    } finally {

      setIsSubmitting(false);

    }

  };



  return (

    <div className="min-h-screen overflow-x-hidden bg-stone-100 text-slate-900">

      <header className="fixed left-0 right-0 top-0 z-50 border-b border-[#d6e0ef] bg-white/95 backdrop-blur">

        <nav className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-2 sm:px-6 lg:px-8 lg:py-3">
          <button className="flex items-center" onClick={scrollToQuote} type="button">

            <img alt={t.footer.company} className="h-14 w-auto sm:h-18 lg:h-24" src={brandLogo} />

          </button>



          <div className="order-3 flex w-full items-center justify-center gap-5 text-sm font-semibold text-[#123B7A] sm:gap-8 md:order-2 md:w-auto md:text-lg">

            <a href="#home">{t.nav.home}</a>

            <a href="#services">{t.nav.services}</a>

            <a href="#process">{t.nav.process}</a>

            <a href="#contact">{t.nav.contact}</a>

          </div>



          <div className="order-2 ml-auto flex items-center gap-2 rounded-2xl border border-[#d6e0ef] bg-white p-1 shadow-sm md:order-3 md:ml-0">

            {["pt", "en"].map((lang) => (

              <button

                key={lang}

                className={

                  language === lang

                    ? "rounded-xl bg-[#123B7A] px-3 py-2 text-sm font-semibold uppercase tracking-[0.18em] text-white sm:px-5 sm:py-2.5 sm:text-base"

                    : "rounded-xl px-3 py-2 text-sm font-semibold uppercase tracking-[0.18em] text-[#123B7A] transition-colors hover:bg-[#eef4fb] sm:px-5 sm:py-2.5 sm:text-base"

                }

                onClick={() => setLanguage(lang)}

                type="button"

              >

                {lang}

              </button>

            ))}

          </div>

        </nav>

      </header>



      <main className="pt-[88px] sm:pt-[96px] lg:pt-[104px]">
        <section id="home" className="relative overflow-hidden">

          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${heroImage})` }} />

          <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(2,6,23,0.78)_0%,rgba(2,6,23,0.72)_36%,rgba(2,6,23,0.64)_100%)] lg:bg-[linear-gradient(90deg,rgba(2,6,23,0.86)_0%,rgba(2,6,23,0.72)_42%,rgba(2,6,23,0.42)_68%,rgba(2,6,23,0.62)_100%)]" />

          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(245,158,11,0.22),_transparent_32%),radial-gradient(circle_at_bottom_right,_rgba(15,23,42,0.16),_transparent_36%)]" />



          <div className="relative mx-auto grid max-w-6xl gap-8 px-4 py-10 sm:px-6 sm:py-14 lg:grid-cols-[1.08fr_0.92fr] lg:gap-10 lg:px-8 lg:py-24">

            <div className="space-y-6 lg:space-y-8">

              <div className="inline-flex max-w-full rounded-full border border-amber-300/70 bg-amber-50/12 px-4 py-1 text-xs text-amber-100 backdrop-blur-sm sm:text-sm">

                {t.hero.support}

              </div>



              <div className="space-y-4 lg:space-y-5">
                <h1 className="max-w-3xl font-serif text-4xl leading-tight text-white sm:text-5xl lg:text-7xl">{t.hero.title}</h1>
                <p className="max-w-2xl text-base leading-7 text-slate-200 sm:text-lg sm:leading-8">{t.hero.subtitle}</p>
              </div>

              <div className="flex w-full max-w-[640px] flex-col gap-4 rounded-[1.5rem] border border-white/15 bg-white/8 p-4 text-white backdrop-blur-sm md:flex-row md:items-center md:justify-between">
                <div>
                  <p className="text-xs uppercase tracking-[0.28em] text-[#ffd071]">
                    {language === "pt" ? "Orçamento grátis" : "Free quote"}
                  </p>
                  <p className="mt-1 text-sm text-slate-100">
                    {language === "pt" ? "Fale connosco diretamente para validar percurso e disponibilidade." : "Talk to us directly to confirm route and availability."}
                  </p>
                </div>
                <div className="flex shrink-0 flex-col gap-2 sm:flex-row md:flex-col">
                  <a
                    className="inline-flex min-w-[180px] items-center justify-center gap-3 whitespace-nowrap rounded-full bg-white px-5 py-3.5 text-base font-semibold text-[#0A2A57] transition-colors hover:bg-[#eef4fb] sm:min-w-[204px]"
                    href={`https://wa.me/${getWhatsAppPhone(t.footer.phone)}?text=${encodeURIComponent(
                      language === "pt" ? "Olá, gostaria de pedir um orçamento." : "Hello, I would like to request a quote."
                    )}`}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img alt="" className="h-6 w-6 shrink-0 object-contain sm:h-7 sm:w-7" src={whatsappHeroIcon} />
                    {t.footer.phone}
                  </a>
                  <a
                    className="inline-flex min-w-[180px] items-center justify-center gap-3 rounded-full border border-amber-200/80 bg-amber-400 px-5 py-3.5 text-sm font-semibold text-[#0A2A57] shadow-[0_12px_30px_rgba(245,158,11,0.24)] transition-colors hover:bg-amber-300 sm:min-w-[204px]"
                    href={COMPANY_INSTAGRAM_URL}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Instagram className="h-5 w-5 shrink-0" />
                    <span>{language === "pt" ? "Instagram da empresa" : "Company Instagram"}</span>
                  </a>
                </div>
              </div>

              <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
                {t.hero.badges.map((badge) => (
                  <span
                    key={badge}
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-2 text-sm text-white shadow-sm backdrop-blur-sm sm:justify-start"

                  >

                    <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-300" />

                    {badge}

                  </span>

                ))}

              </div>



            </div>



            <Card id="quote-form" className="border-0 bg-white shadow-[0_24px_80px_rgba(15,23,42,0.12)]">
              <CardContent className="p-5 sm:p-8">
                <div className="mb-6 space-y-2">
                  <p className="text-xs uppercase tracking-[0.28em] text-[#F59E0B]">
                    {language === "pt" ? "Resposta rápida" : "Fast reply"}
                  </p>
                  <h2 className="font-serif text-3xl text-slate-950 sm:text-4xl">{t.form.title}</h2>
                  <p className="text-sm leading-6 text-slate-600">{t.form.intro}</p>
                </div>


                <form className="space-y-4" onSubmit={handleSubmit}>

                  <div>

                    <Label htmlFor="name">{t.form.name}</Label>

                    <Input id="name" required value={formData.name} onChange={(event) => handleInputChange("name", event.target.value)} />

                  </div>



                  <div className="grid gap-4 sm:grid-cols-2">

                    <div>

                      <Label htmlFor="phone">{t.form.phone}</Label>

                      <Input id="phone" required type="tel" value={formData.phone} onChange={(event) => handleInputChange("phone", event.target.value)} />

                    </div>

                    <div>

                      <Label htmlFor="email">{t.form.email}</Label>

                      <Input id="email" required type="email" value={formData.email} onChange={(event) => handleInputChange("email", event.target.value)} />

                    </div>

                  </div>



                  <div className="grid gap-4 sm:grid-cols-2">

                    <div>

                      <Label htmlFor="from-city">{t.form.from}</Label>

                      <Input

                        id="from-city"

                        required

                        value={formData.fromCity}

                        onChange={(event) => handleInputChange("fromCity", event.target.value)}

                      />

                    </div>

                    <div>

                      <Label htmlFor="to-city">{t.form.to}</Label>

                      <Input id="to-city" required value={formData.toCity} onChange={(event) => handleInputChange("toCity", event.target.value)} />

                    </div>

                  </div>



                  <div className="grid gap-4 sm:grid-cols-2">

                    <div>

                      <Label htmlFor="move-date">{t.form.date}</Label>

                      <Input

                        id="move-date"

                        required

                        type="date"

                        value={formData.moveDate}

                        onChange={(event) => handleInputChange("moveDate", event.target.value)}

                      />

                    </div>

                    <div>

                      <Label htmlFor="home-size">{t.form.size}</Label>

                      <Select required value={formData.homeSize} onValueChange={(value) => handleInputChange("homeSize", value)}>

                        <SelectTrigger id="home-size">

                          <SelectValue placeholder={t.form.sizePlaceholder} />

                        </SelectTrigger>

                        <SelectContent>

                          {t.form.sizeOptions.map((option) => (

                            <SelectItem key={option} value={option}>

                              {option}

                            </SelectItem>

                          ))}

                        </SelectContent>

                      </Select>

                    </div>

                  </div>



                  <div>

                    <Label htmlFor="notes">{t.form.notes}</Label>

                    <Textarea

                      id="notes"

                      value={formData.notes}

                      onChange={(event) => handleInputChange("notes", event.target.value)}

                      placeholder={t.form.notesPlaceholder}

                    />

                  </div>



                  <Button className="w-full bg-[#F59E0B] py-6 text-base text-white hover:bg-[#dd8d09]" disabled={isSubmitting} type="submit">
                    {isSubmitting ? t.form.sending : t.form.submit}
                  </Button>
                </form>

              </CardContent>

            </Card>

          </div>

        </section>



        <section className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:px-8">

          <div className="grid gap-4 md:grid-cols-3">

            {valueCards.map((card) => (

              <Card key={card.en.title} className="border-0 bg-slate-950 text-white">

                <CardContent className="space-y-4 p-6">

                  <card.icon className="h-8 w-8 text-amber-400" />

                  <h3 className="font-serif text-2xl">{card[language].title}</h3>

                  <p className="text-sm leading-6 text-slate-300">{card[language].description}</p>

                </CardContent>

              </Card>

            ))}

          </div>

        </section>



        <section className="pb-8">

          <div className="mx-auto grid max-w-6xl gap-6 px-4 sm:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:px-8">

            <div className="relative overflow-hidden rounded-[2rem] bg-slate-950 shadow-[0_24px_80px_rgba(15,23,42,0.18)]">

              <img alt="Frota Andrade em operação" className="h-[280px] w-full object-cover sm:h-[420px]" src={frota1Image} />

              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/20 to-transparent" />

              <div className="absolute inset-x-0 bottom-0 p-5 text-white sm:p-8">

                <p className="text-xs uppercase tracking-[0.3em] text-amber-300">{language === "pt" ? "Imagem real" : "Real fleet"}</p>

                <h2 className="mt-3 max-w-xl font-serif text-2xl sm:text-3xl">

                  {language === "pt" ? "A operação não fica escondida em stock photos." : "The operation is not hidden behind stock photos."}

                </h2>

                <p className="mt-3 max-w-2xl text-sm leading-7 text-white/80">

                  {language === "pt"

                    ? "Mostramos a frota real para reforçar o tipo de serviço que a equipa executa no terreno."

                    : "We show the real fleet to reinforce the type of service the team actually delivers on the ground."}

                </p>

              </div>

            </div>



            <div className="grid gap-6">

              <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-[0_18px_50px_rgba(15,23,42,0.10)]">

                <img alt="Veículo Andrade estacionado" className="h-56 w-full object-cover sm:h-64" src={frota2Image} />

              </div>

              <div className="rounded-[2rem] border border-[#dce5f3] bg-[#eef4fb] p-6 text-slate-900 shadow-[0_18px_50px_rgba(10,42,87,0.08)] sm:p-8">

                <p className="text-xs uppercase tracking-[0.3em] text-[#F59E0B]">{language === "pt" ? "No terreno" : "On site"}</p>

                <p className="mt-4 font-serif text-2xl leading-tight text-[#0A2A57] sm:text-3xl">

                  {language === "pt"

                    ? "Equipas, viaturas e rota alinhadas antes do dia da mudança."

                    : "Crews, vehicles, and route aligned before move day."}

                </p>

                <p className="mt-4 text-sm leading-7 text-slate-600">

                  {language === "pt"

                    ? "Isto reduz improviso, melhora a comunicação e torna o processo mais previsível para o cliente."

                    : "That reduces improvisation, improves communication, and makes the process more predictable for the client."}

                </p>

              </div>

            </div>

          </div>

        </section>



        <section id="services" className="bg-white py-16 sm:py-20">

          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">

            <div className="mb-12 max-w-2xl">

              <p className="text-sm uppercase tracking-[0.3em] text-amber-700">{t.nav.services}</p>

              <h2 className="mt-3 font-serif text-3xl text-slate-950 sm:text-4xl">{t.sections.servicesTitle}</h2>

              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg sm:leading-8">{t.sections.servicesSubtitle}</p>

            </div>



            <div className="grid gap-6 md:grid-cols-3">

              {serviceCards.map((card) => (

                <Card key={card.en.title} className="border-slate-200 bg-stone-50">

                  <CardContent className="space-y-4 p-6">

                    <card.icon className="h-8 w-8 text-amber-700" />

                    <h3 className="font-serif text-2xl text-slate-950">{card[language].title}</h3>

                    <p className="text-sm leading-6 text-slate-600">{card[language].description}</p>

                  </CardContent>

                </Card>

              ))}

            </div>

          </div>

        </section>



        <section className="bg-[#eef4fb] py-16 sm:py-20">

          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">

            <div className="mb-10 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">

              <div className="max-w-2xl">

                <p className="text-sm uppercase tracking-[0.3em] text-[#F59E0B]">{language === "pt" ? "Carrossel" : "Carousel"}</p>

                <h2 className="mt-3 font-serif text-3xl text-[#0A2A57] sm:text-4xl">

                  {language === "pt" ? "Cada mudança tem etapas diferentes" : "Every move has different stages"}

                </h2>

                <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg sm:leading-8">

                  {language === "pt"

                    ? "Usamos preparação, proteção e organização como base do serviço."

                    : "We treat preparation, protection, and organisation as part of the service."}

                </p>

              </div>

              <div className="text-sm text-slate-500">{language === "pt" ? "Deslize ou use as setas" : "Swipe or use the arrows"}</div>

            </div>



            <Carousel className="mx-auto w-full max-w-6xl" opts={{ align: "start", loop: true }}>

              <CarouselContent className="-ml-0 md:-ml-4">

                {gallerySlides.map((slide) => (

                  <CarouselItem key={slide.en.title} className="basis-full pl-0 md:basis-1/2 md:pl-4 lg:basis-[45%]">

                    <div className="overflow-hidden rounded-[2rem] border border-[#dce5f3] bg-white shadow-[0_20px_50px_rgba(10,42,87,0.10)]">

                      <div className="relative">

                        <img alt={slide[language].title} className="h-[300px] w-full object-cover sm:h-[360px]" src={slide.image} />

                        <div className="absolute inset-0 bg-gradient-to-t from-[#0A2A57]/88 via-[#0A2A57]/10 to-transparent" />

                        <div className="absolute inset-x-0 bottom-0 p-6 text-white">

                          <p className="text-xs uppercase tracking-[0.3em] text-[#ffd071]">{slide[language].eyebrow}</p>

                          <h3 className="mt-3 font-serif text-2xl sm:text-3xl">{slide[language].title}</h3>

                        </div>

                      </div>

                      <div className="p-6">

                        <p className="text-sm leading-7 text-slate-600">{slide[language].text}</p>

                      </div>

                    </div>

                  </CarouselItem>

                ))}

              </CarouselContent>

              <CarouselPrevious className="left-3 top-36 border-0 bg-white text-[#123B7A] shadow-lg hover:bg-[#123B7A] hover:text-white md:-left-4" />

              <CarouselNext className="right-3 top-36 border-0 bg-white text-[#123B7A] shadow-lg hover:bg-[#123B7A] hover:text-white md:-right-4" />

            </Carousel>

          </div>

        </section>



        <section id="process" className="py-16 sm:py-20">

          <div className="mx-auto grid max-w-6xl gap-10 px-4 sm:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-12 lg:px-8">

            <div>

              <p className="text-sm uppercase tracking-[0.3em] text-amber-700">{t.nav.process}</p>

              <h2 className="mt-3 font-serif text-3xl text-slate-950 sm:text-4xl">{t.sections.processTitle}</h2>

              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg sm:leading-8">{t.sections.processSubtitle}</p>

            </div>



            <div className="grid gap-4">

              {processSteps[language].map((step, index) => (

                <div key={step} className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">

                  <div className="flex items-start gap-4">

                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-slate-950 text-sm font-semibold text-white">

                      {index + 1}

                    </div>

                    <p className="pt-2 text-base leading-7 text-slate-700">{step}</p>

                  </div>

                </div>

              ))}

            </div>

          </div>

        </section>



        <section className="bg-slate-950 py-16 text-white sm:py-20">

          <div className="mx-auto grid max-w-6xl gap-10 px-4 sm:px-6 lg:grid-cols-[0.95fr_1.05fr] lg:gap-12 lg:px-8">

            <div>

              <p className="text-sm uppercase tracking-[0.3em] text-amber-300">{t.sections.coverageTitle}</p>

              <h2 className="mt-3 font-serif text-3xl sm:text-4xl">{t.sections.coverageTitle}</h2>

              <p className="mt-4 text-base leading-7 text-slate-300 sm:text-lg sm:leading-8">{t.sections.coverageSubtitle}</p>

            </div>



            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">

              {coverage[language].map((place) => (

                <div key={place} className="rounded-2xl border border-slate-800 bg-slate-900 px-4 py-5">

                  <div className="flex items-center gap-3">

                    <MapPin className="h-5 w-5 shrink-0 text-amber-300" />

                    <span>{place}</span>

                  </div>

                </div>

              ))}

            </div>

          </div>

        </section>



        <section className="bg-white py-16 sm:py-20">

          <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">

            <h2 className="font-serif text-3xl text-slate-950 sm:text-4xl">{t.sections.finalTitle}</h2>

            <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg sm:leading-8">{t.sections.finalText}</p>

            <Button className="mt-8 w-full bg-amber-600 px-8 py-6 text-base text-white hover:bg-amber-500 sm:w-auto" onClick={scrollToQuote} size="lg">

              {t.sections.finalButton}

            </Button>

          </div>

        </section>

      </main>



      <footer id="contact" className="border-t border-[#d6e0ef] bg-[#f8fbff] text-[#0A2A57]">
        <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">

          <div className="grid gap-10 lg:grid-cols-[1.2fr_0.9fr_0.9fr]">

            <div className="space-y-4 text-center md:text-left">

              <img alt={t.footer.company} className="mx-auto h-14 w-auto md:mx-0 sm:h-16" src={brandLogo} />

              <p className="max-w-md text-sm leading-7 text-slate-600">{t.footer.about}</p>
              <div className="inline-flex rounded-full border border-[#d6e0ef] bg-white px-4 py-2 text-xs uppercase tracking-[0.28em] text-[#F59E0B]">
                {language === "pt" ? "Portugal + Europa" : "Portugal + Europe"}

              </div>

            </div>



            <div className="space-y-4 text-center md:text-left">

              <p className="text-xs uppercase tracking-[0.3em] text-[#F59E0B]">{language === "pt" ? "Contacto" : "Contact"}</p>
              <div className="space-y-3 text-sm text-slate-600">
                <div className="flex items-center justify-center gap-3 md:justify-start">

                  <Phone className="h-4 w-4 shrink-0 text-[#F59E0B]" />

                  <div className="flex flex-col">
                    {t.footer.phones.map((phone) => (
                      <span key={phone}>{phone}</span>
                    ))}
                  </div>

                </div>

                <div className="flex items-center justify-center gap-3 md:justify-start">

                  <Mail className="h-4 w-4 shrink-0 text-[#F59E0B]" />

                  <span>{t.footer.email}</span>

                </div>

                <a
                  className="flex items-center justify-center gap-3 rounded-full border border-[#d6e0ef] bg-white px-4 py-3 font-semibold text-[#0A2A57] transition-colors hover:border-[#F59E0B] hover:text-[#F59E0B] md:justify-start"
                  href={COMPANY_INSTAGRAM_URL}
                  rel="noreferrer"
                  target="_blank"
                >

                  <Instagram className="h-4 w-4 shrink-0 text-[#F59E0B]" />

                  <span>{t.footer.instagram}</span>

                </a>

                <div className="flex items-center justify-center gap-3 md:justify-start">

                  <Clock className="h-4 w-4 shrink-0 text-[#F59E0B]" />

                  <span>{t.footer.hours}</span>

                </div>

              </div>

            </div>



            <div className="space-y-4 text-center md:text-left">

              <p className="text-xs uppercase tracking-[0.3em] text-[#F59E0B]">{language === "pt" ? "Presença" : "Coverage"}</p>

              <div className="grid grid-cols-2 gap-3 text-sm text-slate-600">
                {coverage[language].slice(0, 6).map((place) => (
                  <div key={place} className="rounded-2xl border border-[#d6e0ef] bg-white px-3 py-3">
                    {place}
                  </div>
                ))}
              </div>
            </div>

          </div>



          <div className="mt-10 flex flex-col gap-3 border-t border-[#d6e0ef] pt-6 text-center text-sm text-slate-500 md:flex-row md:items-center md:justify-between md:text-left">
            <p>{t.footer.copyright}</p>

            <p>

              made by{" "}

              <a className="text-[#F59E0B] transition-colors hover:text-[#0A2A57]" href="https://perolamagnetizante.pt" rel="noreferrer" target="_blank">
                perolamagnetizante.pt

              </a>

            </p>

          </div>

        </div>

      </footer>



      <a

        aria-label={language === "pt" ? "Falar no WhatsApp" : "Chat on WhatsApp"}

        className="fixed bottom-5 right-5 z-[70] inline-flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-[0_18px_40px_rgba(10,42,87,0.2)] ring-1 ring-[#d6e0ef] transition-transform duration-200 hover:scale-105 hover:shadow-[0_22px_48px_rgba(10,42,87,0.24)] sm:bottom-6 sm:right-6 sm:h-16 sm:w-16"

        href={`https://wa.me/${getWhatsAppPhone(t.footer.phone)}?text=${encodeURIComponent(

          language === "pt" ? "Ol?, gostaria de pedir um or?amento." : "Hello, I would like to request a quote."

        )}`}

        rel="noreferrer"

        target="_blank"

      >

        <img alt="WhatsApp" className="h-12 w-12 object-contain sm:h-14 sm:w-14" src={whatsappIcon} />

      </a>

    </div>

  );

}



export default LandingPage;


